export enum ContractType {
  PLAYER = 'PLAYER',
  COACH = 'COACH',
  STAFF = 'STAFF',
  OTHER = 'OTHER',
}